import React, {useState} from "react";
import {useSearchParams} from "react-router-dom";
import {TopnavSearchDropdown} from "@components/topnav-search-dropdown";

const HomePageSearchBox = ({showDesktopView}) => {
    const [searchParams] = useSearchParams();
    const [query, setQuery] = useState(String(searchParams.has("search") ? searchParams.get("search") : ""));

    return (
        <TopnavSearchDropdown query={query} background={"gradient"} isOnPage={true} />
    );
};

export default HomePageSearchBox;